import React from 'react';
import Campo from './Campo';

interface Direccion {
    region: {
        codigo: string;
        nombre: string;
    };
    comuna: {
        codigo: string;
        nombre: string;
    };
    calle: string;
    numero: string;
    dpto?: string;
    block?: string;
    poblacion?: string;
}

interface Props {
    titulo: string;
    direccion: Direccion;
}
export const CampoDireccion: React.FunctionComponent<Props> = props => {
    const { titulo, direccion } = props;

    if (direccion.calle.length === 0) {
        return null;
    }

    const { dpto, block, calle, comuna, numero, poblacion, region } = direccion;

    const textoDpto = dpto ? `, dpto ${dpto}` : '';
    const textoBlock = block ? `, block ${block}` : '';
    const textoPoblacion = poblacion ? `, población ${poblacion}` : '';

    const textoDireccion =
        calle +
        ' #' +
        numero +
        textoDpto +
        textoBlock +
        textoPoblacion +
        ', ' +
        comuna.nombre +
        ', Región ' +
        region.nombre;

    return (
        <div>
            <Campo etiqueta={titulo} valor={textoDireccion} />
        </div>
    );
};

export default CampoDireccion;



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/FichaDeApoderado/VistaDireccion.tsx